/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/user/action/userActionTypes';

import type { State } from 'src/shared/core/type/reduxTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const setUserFetchingSuccess = (state: State, { userId }: Object) => {
  const userState = state[userId] || {};

  return {
    ...state,
    [userId]: {
      ...userState,
      isFetching: false,
      fetchingError: false,
      isFetched: true,
    },
  };
};

const setUserFetchingError = (state: State, { userId, exception }: Object) => {
  const userState = state[userId] || {};

  return {
    ...state,
    [userId]: {
      ...userState,
      isFetching: false,
      fetchingError: exception.message,
    },
  };
};

const setUserFetching = (state: State, { userId }: Object) => {
  const userState = state[userId] || {};

  return {
    ...state,
    [userId]: {
      ...userState,
      isFetching: true,
      fetchingError: false,
    },
  };
};

export default createReducer(initialState, {
  [types.FETCH_USER_SUCCESS]: setUserFetchingSuccess,
  [types.FETCH_USER_FAILURE]: setUserFetchingError,
  [types.FETCH_USER_REQUEST]: setUserFetching,
});
